// Cross-browser helper to request fullscreen on <html>, with iPad-safe early exit.
import { isIPad } from './isIPad';

export async function requestFullscreen(): Promise<boolean> {
  // iPad Safari doesn't expose a reliable fullscreen UX; treat inline as "ready".
  if (isIPad()) return true;
  try {
    const el = document.documentElement as HTMLElement & {
      webkitRequestFullscreen?: () => Promise<void> | void;
      msRequestFullscreen?: () => Promise<void> | void;
    };
    // already fullscreen
    if (document.fullscreenElement) return true;
    if (el.requestFullscreen) {
      await el.requestFullscreen();
      return true;
    }
    if (el.webkitRequestFullscreen) {
      el.webkitRequestFullscreen();
      return true;
    }
    if (el.msRequestFullscreen) {
      el.msRequestFullscreen();
      return true;
    }
  } catch {
    // ignored
  }
  // last-chance check (some browsers are quirky about timing)
  return !!document.fullscreenElement;
}

export default requestFullscreen;
